import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)


// calculate font size
function setMainFontSize(){
  let fontCoef = window.innerWidth / 1920
  let fontSize = Math.floor(62.5 * fontCoef)
  $('html').css('font-size', fontSize + '%')
}

if (window.innerWidth > 1900) {
  setMainFontSize()
  window.addEventListener('resize', function(event){
    setMainFontSize()
  });
}

let is_ios = ['iPad', 'iPhone', 'iPod'].indexOf(navigator.platform) >= 0;
if (is_ios) $('body').addClass('is-ios')
let msie = window.navigator.userAgent.indexOf("MSIE ")
if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) $('body').addClass('is-explorer')
$('table').each(function () {$(this).wrap('<div class=\'table-container\'></div>')})



function menuAndPopups(){

  function openPopup(popup_class){
    $('body').addClass('modal-open')
    $(popup_class).css('display', 'block')
    $('.js-burger').css('opacity',0)
  }

  function closePopup(){
    $('.popup').css('display', 'none')
    $('.js-burger').css('opacity',1)
    $('body').removeClass('modal-open')
  }

  $('.js-open-menu').click(function (){
    openPopup('.js-menu')
  })
  $('.js-close-popup').click(function (){
    closePopup()
  })
  $('.search-b').click(function (){
    setTimeout(function(){
      $('.js-search-input').focus()
    }, 600)
  })


  $('.js-open-popup').click(function (){
    openPopup('.js-'+$(this).data('popup'))
  })

  // front burger color change
  setTimeout(function() {
    let top_section = $('.top-section')
    if (top_section.length) {
      $(window).scroll(function (event) {
        let scroll = $(window).scrollTop()
        let hit_point = top_section.offset().top - 120
        if (scroll > hit_point) {
          $('.js-open-menu').addClass('red')
        } else {
          $('.js-open-menu').removeClass('red')
        }
      })
    }
  }, 500)


  // open page burger color
  let inner_page_header = $('.search-header')
  if (inner_page_header.length) {
    $(window).scroll(function (event) {
      let scroll = $(window).scrollTop();
      let hit_point = 20
      if (scroll > hit_point) {
        $('.js-open-menu').addClass('red')
      } else {
        $('.js-open-menu').removeClass('red')
      }
    })
  }


  // accardeon
  function toggleAccardeon(el){
    let accardeon = el.parent()
    if (!accardeon.hasClass('opened')) {
      $('.accardeon-el').each(function () {
        if ($(this).hasClass('opened')) {
          $(this).removeClass('opened')
          $(this).find('.accardeon-el-content').slideUp()
        }
      })
    }

    accardeon.toggleClass('opened')
    accardeon.find('.accardeon-el-content').slideToggle()
  }
  $('.accardeon-el-h').click(function(){
    toggleAccardeon($(this))
  })
  $('.accardeon-el .arrow').click(function(){
    toggleAccardeon($(this))
  })


  // input focus
  $(document).on('focusin', '.input-c input', function () {
    $(this).parent().addClass('focus');
  });
  $(document).on('focusout', '.input-c input', function () {
    if ($(this).val() == '') {
      $(this).parent().removeClass('focus');
    }
  });

  $('.input-c input').each(function(){
    if ($(this).val() !=- ''){
      $(this).parent().addClass('focus');
    }
  })
  $('form.focused').find('.input-c input').parent().addClass('focus')



}




//--- custom lazy load without viewport checker
let imgSize = 'data-src'
if (window.innerWidth <= 700) {
  imgSize = 'data-small'
} else if (window.innerWidth <= 1024 && window.innerWidth > 700) {
  imgSize = 'data-medium'
} else if (window.innerWidth > 2000) {
  imgSize = 'data-x-large'
}
let last_scroll_top = $(window).scrollTop() - 1
const animate_offset = -100
const lazy_offset = 300

// out of main function, to be global
function loadElementLazyImage (elements) {
  elements.each(function () {
    let elem = $(this)
    let imgSrc = elem.attr(imgSize)

    let nodname = elem[0]['nodeName']
    let position = elem.attr('data-position')
    if (!imgSrc) { imgSrc = elem.attr('data-src') }
    if (!position) position = 'center'

    if (nodname != 'IMG' && nodname != 'IFRAME') {
      elem.css('background', 'url(' + imgSrc + ') no-repeat ' + position)
      elem.css('background-size', 'cover')
    } else {
      elem.attr('src', imgSrc)
    }
  })
}

const simpleLazyLoadAnimateIn = function () {
  // add elements animation function
  function animated (elem) {
    if (isScrolledIntoView(elem, animate_offset && elem.offsetParent !== null)) elem.addClass('in-screen')
  }
  // check if in screeen
  function isScrolledIntoView (elem, offset) {
    let docViewTop = $(window).scrollTop()
    let docViewBottom = docViewTop + $(window).height()
    let elemTop = elem.offset().top - offset
    let elemBottom = elemTop + elem.outerHeight() + (offset * 2)
    if (last_scroll_top < docViewTop) {
      return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom))
    } else {
      return ((elemBottom >= docViewTop) && (elemTop <= docViewTop))
    }
  }

  function loadLazyImages () {
    $('.lazy').each(function (i, l) {
      if (isScrolledIntoView($(this), lazy_offset)) {
        loadElementLazyImage($(this))
        $(this).removeClass('lazy')
      }
    })

    $('.fade-in').each(function () { animated($(this)) })
    $('.fade-from-top').each(function () { animated($(this)) })
    $('.fade-from-bottom').each(function () { animated($(this)) })
    $('.rotate-in').each(function () { animated($(this)) })
  }

  $(document).ready(function() {
    setTimeout(function() {
      $(window).scroll(function () {
        loadLazyImages()
        last_scroll_top = $(window).scrollTop()
      })
      $(window).resize(function () { loadLazyImages() })

      loadLazyImages()
    }, 400)
  })
}

// -- End Custom lazy load


function select(){

  // select
  $('.dropdown-h').click(function (){
    let parent = $(this).parent()
    parent.toggleClass('opened')
    parent.find('.dropdown-content').slideToggle()
  })

  $('.dropdown-val').click(function (){
    let order = $(this).attr('data-val')
    let select = $(this).closest('.dropdown').find('.dropdown-h')
    let load_more = $('.js-load-more')

    select.attr('val', order).click().find('span').text($(this).text())
    load_more.attr('data-page', 1).attr('data-order', order).click()

    $('.js-search-results').html('')

    $("html, body").animate({ scrollTop: $('.js-search-results').offset().top - 150 }, 400);

  })

  $(document).click(function(event) {
    if(!$(event.target).closest('.dropdown-h').length) {
      $('.dropdown-content').css('display', 'none')
      $('.dropdown').removeClass('opened')
    }
  });

  // sticky select
  setTimeout(function () {
    const select = '.filter-dropdown-c'
    ScrollTrigger.create({
        start: 'top top',
        end: '+=100000000',
        trigger: select,
        toggleClass: 'fixed',
    })
  }, 1000)

}

function animations(){
  let from_top_onload = $('.js-fade-from-top-on-load')
  if (from_top_onload.length){
    gsap.to(from_top_onload, {'opacity':1, 'top': 0})
  }

  $('.info-popup-content a').addClass('underline')
}

function cookies(){
  function getCookie (cname) {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i]
      while (c.charAt(0) == ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ''
  }

  function setCookie (cname, cValue, exDays) {
    let d = new Date()
    d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000))
    let expires = 'expires=' + d.toUTCString()
    document.cookie = cname + '=' + cValue + ';' + expires + ';path=/'
  }


  if (!getCookie('cookies_accepted')) {
    $('.js-cookies-popup').fadeIn()
  }
  $('.js-accept-cookies').on('click', function(e) {
    e.preventDefault()
    setCookie('cookies_accepted', 1, 30)
    $('.js-cookies-popup').fadeOut(300)
  });

}




function initApp(){
  menuAndPopups()
  simpleLazyLoadAnimateIn()
  select()
  animations()
  cookies()
}

initApp()


export { loadElementLazyImage }
